// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8cbd9d7d","455":"2c0a265e"}[chunkId] + ".chunk.js";
};